import {
  ChangeDetectionStrategy,
  Component,
  Injector,
  OnInit,
  Optional,
} from '@angular/core';
import {
  AbstractControl,
  ControlContainer,
  FormControl,
  NgControl,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { ControlValueAccessor, FormGroup } from '@ngneat/reactive-forms';

@Component({
  selector: 'bs-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: CheckboxComponent,
      multi: true,
    },
  ],
})
export class CheckboxComponent implements OnInit, ControlValueAccessor {
  value: any;
  ngControl!: NgControl | null;
  onChange?: (value: boolean) => void;
  onTouched?: () => void;
  writeValue(value: boolean): void {
    this.value = value;
  }

  registerOnChange(fn: (value: any) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  checkboxControl = new FormControl(false);

  constructor(
    private readonly injector: Injector,
    @Optional() private readonly controlContainer: ControlContainer
  ) {}

  ngOnInit(): void {
    this.checkboxControl.valueChanges.subscribe((value: any) => {
      this.onChange?.apply(this, [value]);
      this.writeValue(value);
    });

    this.ngControl = this.injector.get(NgControl, null);

    if (this.ngControl && this.ngControl.control) {
      this.checkboxControl.validator = this.ngControl.control.validator;
    }

    const hasControl = this.controlContainer && this.controlContainer.control;

    if (!hasControl && this.controlContainer) {
      const formGroup = this.controlContainer.control as FormGroup<any>;
      const key = this.ngControl!.name as keyof FormGroup<any>;
      const control = formGroup.get(key) as AbstractControl;
      this.checkboxControl.validator = control.validator;
    }
  }
}
